import { BusinessInterface } from '@app/models/business';
import { UserInterface } from '@app/models/user';

export enum AuditLogAction {
  ACCOUNT_DISABLE = 'ACCOUNT_DISABLE',
  ACCOUNT_ENABLE = 'ACCOUNT_ENABLE',
  ACCOUNT_DELETE = 'ACCOUNT_DELETE',
  IMPERSONATION_START = 'IMPERSONATION_START',
  PLAN_CHANGE = 'PLAN_CHANGE',
  USER_ROLE_CHANGE = 'USER_ROLE_CHANGE',
  SUBSCRIPTION_FEATURES_CHANGED = 'SUBSCRIPTION_FEATURES_CHANGED',
}

export interface AuditLogMetadata {
  [key: string]: any;
}

export interface AuditLogInterface {
  id: string;
  action: AuditLogAction;
  metadata?: AuditLogMetadata;
  adminId: string;
  userId?: string;
  businessId?: string;
  admin: UserInterface;
  user?: UserInterface;
  business?: BusinessInterface;
  createdAt: string;
}
